class SchemaService {
  getType(typename) {
    return typename;
  }

  isEnum(/* type */) {
    return false;
  }

  getEnumNamedValues(/* type */) {
    return [];
  }
}

export default SchemaService;
